import * as types from '../../contactUs/constants/ActionTypes';
import * as consts from '../constants/ActionTypes';

const initialState = {
  experience: '',
  tab: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SWITCH_CONTENT_TOGGLE:
      return { ...state, experience: action.payload };
    case consts.TOGGLE_RELATED:
      return { ...state, tab: action.payload };
    case consts.RECEIVE_COMMUNITY_ERROR:
      return { ...state, tab: 'ErrorCommunity' };
    case types.RECEIVE_RELATED_ARTICLE_ERROR:
      return { ...state, tab: 'ErrorRelated' };
    case consts.RELATED_TOGGLE_RESET:
      return { ...state, tab: 'related' };
    default:
      return state;
  }
}
